var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiChefActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46666 2.83333L7.13333 5.16667H2.66683V19.1667H21.3335V5.16667H16.867L14.5337 2.83333H9.46666ZM8.50016 0.5H15.5002L17.8335 2.83333H22.5002C23.1445 2.83333 23.6668 3.35567 23.6668 4V20.3333C23.6668 20.9777 23.1445 21.5 22.5002 21.5H1.50016C0.855836 21.5 0.333496 20.9777 0.333496 20.3333V4C0.333496 3.35567 0.855836 2.83333 1.50016 2.83333H6.16683L8.50016 0.5ZM12.0002 18C8.45633 18 5.5835 15.1272 5.5835 11.5833C5.5835 8.0395 8.45633 5.16667 12.0002 5.16667C15.544 5.16667 18.4168 8.0395 18.4168 11.5833C18.4168 15.1272 15.544 18 12.0002 18ZM12.0002 15.6667C14.2553 15.6667 16.0835 13.8385 16.0835 11.5833C16.0835 9.32817 14.2553 7.5 12.0002 7.5C9.745 7.5 7.91683 9.32817 7.91683 11.5833C7.91683 13.8385 9.745 15.6667 12.0002 15.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiChefActive);
export default __webpack_public_path__ + "static/media/ai_chef_active.dadcbde4f73ead37c7db88aaa2e52079.svg";
export { ForwardRef as ReactComponent };